import { listOpenAuftraege } from './api'
import { getCachedAuftraege, replaceCachedAuftraege, type CachedAuftrag } from './db'
import { getDevice } from './db'

/** Holt die aktuell offenen Aufträge vom Server und ersetzt den lokalen Cache -- analog zum
 * Sync-Gedanken der Outbox, nur in die andere Richtung (Stammdaten runter statt Ereignisse
 * hoch). Wirft nicht bei Netzwerkfehlern -- der Aufrufer arbeitet dann einfach mit dem
 * zuletzt gecachten Stand weiter (Offline-Fall, Architektur §2 EC-04). */
export async function syncOpenAuftraege(): Promise<CachedAuftrag[]> {
  const device = await getDevice()
  if (!device) return []

  try {
    const auftraege = await listOpenAuftraege(device.deviceId)
    const cached: CachedAuftrag[] = auftraege.map((a) => ({
      auftragId: a.auftragId,
      auftragsnummer: a.auftragsnummer,
      auftraggeberName: a.auftraggeberName,
      auftragszeitraumVon: a.auftragszeitraumVon,
      auftragszeitraumBis: a.auftragszeitraumBis,
      auftragsort: a.auftragsort,
      gewerk: a.gewerk,
      status: a.status,
    }))
    await replaceCachedAuftraege(cached)
    return cached
  } catch {
    return getCachedAuftraege()
  }
}
